import * as React from 'react';
import { fetchApi } from '../../services/api';
import { formatNumber } from '@progress/kendo-intl';
import { RadialGauge } from '@progress/kendo-react-gauges';
import { Button } from '@progress/kendo-react-buttons';

type State = {
  loading: boolean;
  data: TripCountYesterdayResponse;
  error?: string;
}

type Props = {
  filter: { Name: string, Filter: string };
}

export type TripCountYesterdayResponse = {
  Count: number;
  Revenue: number;
  Margin: number;
}

export default class TripCountYesterday extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      data: { Count: 0, Revenue: 0, Margin: 0 },
    }

    this.refreshData = this.refreshData.bind(this);
  }

  public componentDidMount() {
    this.refreshData();
  }

  public refreshData() {
    fetchApi(`/api/Report/TripCountYesterday/${this.props.filter.Filter}`)
      .then((response: TripCountYesterdayResponse) => {
        this.setState({
          loading: false,
          data: response,
          error: undefined,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error?.detail || 'Failed to load data'
        });
      });
  }

  public render() {
    if (this.state.loading) {
      return <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card"></div>;
    }

    if (this.state.error) {
      return (
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card text-center p-3">
          <p style={{ color: '#d32f2f', marginBottom: '10px' }}>{this.state.error}</p>
          <Button onClick={this.refreshData} fillMode='flat'>
            Retry
          </Button>
        </div>
      );
    }

    const max = Math.max(500, this.state.data.Count);

    return <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card report-card-gauge">
            <p>
              <span className="report-card-title">Yesterday's Trip Count - {this.props.filter.Name}</span>
              <br />
              {this.state.data.Count} Trips / {formatNumber(this.state.data.Margin, "c0")} Margin / {formatNumber(this.state.data.Revenue, "c0")} Revenue (Assets No FSC)
            </p>
            <RadialGauge
              transitions={false}
              pointer={{ value: this.state.data.Count }}
              scale={{
                max: max,
                labels: {
                  format: "{0}",
                },
                ranges: [
                  { from: 0, to: 276, color: "#dc3545" },
                  { from: 276, to: 415, color: "#ffc107" },
                  { from: 415, to: max, color: "#198754" }
                ]
              }}
            />
          </div>
  }
}
